var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"body"}},[_vm._m(0),_c('el-row',[_c('el-col',{attrs:{"sm":12,"lg":6}},[_c('el-result',{attrs:{"icon":"success","title":"成功提示"}},[_c('template',{slot:"extra"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.text)+"\n\t\t\t\t")])],2)],1)],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v(" 操作成功\n\t")])
}]

export { render, staticRenderFns }